import { useNavigate } from 'react-router-dom'
import CustomNavbar from '../../components/common/CustomNavbar'
import PageLayout from '../../components/layouts/PageLayout'
import CustomerList from './WalletList';

export default function Wallet() {
  const navigate = useNavigate();
  return (
    <PageLayout customNavbar={
      <CustomNavbar>
        <div className="flex gap-3 items-center w-max">
          <span className="font-bold text-lg uppercase">wallet information</span>
        </div>
      </CustomNavbar>
    }>
      <div className="flex flex-col items-end justify-end sm:flex-row gap-4 sm:items-center">

        <button
          onClick={() => navigate("/admin/wallet/add")}
          className=" flex items-center justify-center px-5 py-3 rounded-4xl bg-brand-blue-gradient text-white font-bold whitespace-nowrap"
        >
          + Add Amount
        </button>

      </div>

      <CustomerList />
    </PageLayout>
  )
}
